export const PERSIAN_TEXTS = {
  // Menu items
  'menu.dashboard': 'داشبورد',
  'menu.games': 'بازی‌ها',
  'menu.ranks': 'رتبه‌ها',
  'menu.matches': 'مسابقات',
  'menu.players': 'بازیکنان',
  'menu.tournaments': 'تورنومنت‌ها',
  'menu.adminPayouts': 'پرداخت‌های ادمین',
  'menu.prizeStructures': 'ساختار جوایز',
  'menu.achievements': 'دستاوردها',
  'menu.news': 'مدیریت اخبار',
  'menu.sliders': 'مدیریت اسلایدر',
  'menu.supportTickets': 'تیکت‌های پشتیبانی',
  'menu.finance': 'داشبورد مالی',

  // Common actions
  'common.add': 'افزودن',
  'common.edit': 'ویرایش',
  'common.delete': 'حذف',
  'common.save': 'ذخیره',
  'common.cancel': 'انصراف',
  'common.close': 'بستن',
  'common.back': 'بازگشت',
  'common.search': 'جستجو',
  'common.filter': 'فیلتر',
  'common.actions': 'عملیات',
  'common.status': 'وضعیت',
  'common.date': 'تاریخ',
  'common.time': 'زمان',
  'common.description': 'توضیحات',
  'common.name': 'نام',
  'common.title': 'عنوان',
  'common.image': 'تصویر',
  'common.upload': 'آپلود',
  'common.select': 'انتخاب',
  'common.yes': 'بله',
  'common.no': 'خیر',
  'common.active': 'فعال',
  'common.inactive': 'غیرفعال',
  'common.pending': 'در انتظار',
  'common.completed': 'تکمیل شده',
  'common.failed': 'ناموفق',
  'common.loading': 'در حال بارگذاری...',
  'common.noData': 'داده‌ای یافت نشد',

  // Auth
  'auth.login': 'ورود',
  'auth.logout': 'خروج',
  'auth.username': 'نام کاربری',
  'auth.password': 'رمز عبور',
  'auth.email': 'ایمیل',
  'auth.loginSuccess': 'ورود موفقیت‌آمیز بود',
  'auth.loginFailed': 'ورود ناموفق بود',
  'auth.logoutSuccess': 'خروج موفقیت‌آمیز بود',

  // Dashboard
  'dashboard.title': 'داشبورد مدیریت',
  'dashboard.welcome': 'خوش آمدید',
  'dashboard.stats': 'آمار کلی',
  'dashboard.totalPlayers': 'کل بازیکنان',
  'dashboard.activeTournaments': 'تورنومنت‌های فعال',
  'dashboard.totalMatches': 'کل مسابقات',
  'dashboard.totalGames': 'کل بازی‌ها',

  // Games
  'games.title': 'مدیریت بازی‌ها',
  'games.addGame': 'افزودن بازی جدید',
  'games.editGame': 'ویرایش بازی',
  'games.gameName': 'نام بازی',
  'games.gameType': 'نوع بازی',
  'games.gameStatus': 'وضعیت بازی',
  'games.gameImage': 'تصویر بازی',
  'games.gameDescription': 'توضیحات بازی',

  // Players
  'players.title': 'مدیریت بازیکنان',
  'players.playerName': 'نام بازیکن',
  'players.playerEmail': 'ایمیل بازیکن',
  'players.playerStatus': 'وضعیت بازیکن',
  'players.playerWallet': 'کیف پول',
  'players.chargeWallet': 'شارژ کیف پول',
  'players.walletAmount': 'مبلغ شارژ',

  // Matches
  'matches.title': 'مدیریت مسابقات',
  'matches.addMatch': 'افزودن مسابقه جدید',
  'matches.editMatch': 'ویرایش مسابقه',
  'matches.matchDate': 'تاریخ مسابقه',
  'matches.matchTime': 'زمان مسابقه',
  'matches.matchStatus': 'وضعیت مسابقه',
  'matches.matchResult': 'نتیجه مسابقه',
  'matches.matchPlayers': 'بازیکنان',
  'matches.matchWinner': 'برنده',
  'matches.matchLoser': 'بازنده',

  // Tournaments
  'tournaments.title': 'مدیریت تورنومنت‌ها',
  'tournaments.addTournament': 'افزودن تورنومنت جدید',
  'tournaments.editTournament': 'ویرایش تورنومنت',
  'tournaments.tournamentName': 'نام تورنومنت',
  'tournaments.tournamentStartDate': 'تاریخ شروع',
  'tournaments.tournamentEndDate': 'تاریخ پایان',
  'tournaments.tournamentStatus': 'وضعیت تورنومنت',
  'tournaments.tournamentParticipants': 'شرکت‌کنندگان',
  'tournaments.tournamentBracket': 'براکت تورنومنت',
  'tournaments.tournamentPrize': 'جایزه',
  'tournaments.startTournament': 'شروع تورنومنت',
  'tournaments.endTournament': 'پایان تورنومنت',

  // Status
  'status.active': 'فعال',
  'status.inactive': 'غیرفعال',
  'status.pending': 'در انتظار',
  'status.approved': 'تایید شده',
  'status.rejected': 'رد شده',
  'status.completed': 'تکمیل شده',
  'status.cancelled': 'لغو شده',
  'status.draft': 'پیش‌نویس',
  'status.published': 'منتشر شده',

  // Messages
  'message.success': 'عملیات با موفقیت انجام شد',
  'message.error': 'خطا در انجام عملیات',
  'message.confirmDelete': 'آیا از حذف این مورد اطمینان دارید؟',
  'message.required': 'این فیلد الزامی است',
  'message.invalidFormat': 'فرمت نامعتبر است',

  // Validation
  'validation.required': 'این فیلد الزامی است',
  'validation.email': 'فرمت ایمیل نامعتبر است',
  'validation.minLength': 'حداقل {min} کاراکتر باید باشد',
  'validation.maxLength': 'حداکثر {max} کاراکتر مجاز است',
  'validation.numeric': 'فقط اعداد مجاز است',
  'validation.positive': 'عدد باید مثبت باشد',
};
